import { eDmQuocTichActionsObj } from "../../action-types/category/IDmQuocTichActions";
import { generateActions } from "../generateActions";

export const quocTichActions = {
  ...generateActions(eDmQuocTichActionsObj, "QUOC_TICH"),
};
